module.exports = __webpack_public_path__ + "static/media/spinach2.e4b857b9.png";